import { render, staticRenderFns } from "./modifyNickname.vue?vue&type=template&id=5229bd75&scoped=true"
import script from "./modifyNickname.vue?vue&type=script&lang=js"
export * from "./modifyNickname.vue?vue&type=script&lang=js"
import style0 from "./modifyNickname.vue?vue&type=style&index=0&id=5229bd75&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5229bd75",
  null
  
)

export default component.exports